import { cn } from '@/context/global/utils/cn';

export type IconNextProps = {
  className?: string;
  size?: number;
};

export default function IconNext({ className = '', size = 32 }: IconNextProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('text-white', className)}
    >
      <path
        d="M5.01367 9.62706V22.3871C5.01367 25.0004 7.85365 26.6404 10.1203 25.3337L15.6536 22.147L21.187 18.947C23.4537 17.6404 23.4537 14.3737 21.187 13.067L15.6536 9.86705L10.1203 6.68041C7.85365 5.37374 5.01367 7.00039 5.01367 9.62706Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.9863 24.2407V7.76074"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
